module.exports = __webpack_public_path__ + "img/home_6.8cc63b49.jpg";